import React, { FunctionComponent } from "react";
import { WarningIcon } from "@phosphor-icons/react";
import { language } from "../../utils/language";
import { Overlay, Card, CloseButton, CloseLink, ErrorMessage } from "./style";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  homeState: HomeStateType;
};

const AveonlineLoginError: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  homeState,
}) => {
  const lang = language[homeState.default_language];

  return (
    <Overlay $isOpen={isOpen} onClick={onClose}>
      <Card onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&#x2715;</CloseButton>
        <WarningIcon size={80} color="#FFDB00" weight="regular" />
        <ErrorMessage>{lang["aveonlineLoginError"]}</ErrorMessage>
        <CloseLink onClick={onClose}>{lang["close"]}</CloseLink>
      </Card>
    </Overlay>
  );
};

export default AveonlineLoginError;
